
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 42.014 40.839"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('filter',{attrs:{"id":"a","x":"0","y":"0","width":"100%","height":"100%","filterUnits":"userSpaceOnUse"}},[_c('feOffset',{attrs:{"dy":"3"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"3","result":"blur"}}),_c('feFlood',{attrs:{"flood-opacity":".161"}}),_c('feComposite',{attrs:{"operator":"in","in2":"blur"}}),_c('feComposite',{attrs:{"in":"SourceGraphic"}})])]),_c('g',{attrs:{"filter":"url(#a)"}},[_c('path',{attrs:{"data-name":"Path 7935","d":"M21.01 6l3.906 7.248 8.1 1.476-5.686 5.955 1.1 8.16-7.421-3.568-7.421 3.568 1.1-8.16-5.686-5.955 8.1-1.476z","fill":"#fff"}})])])
          )
        }
      }
    